export default "__VITE_ASSET__BcQMWt$v__"